import PropTypes from "prop-types";
import { useState } from "react";
import { Button } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { fetchReservationById } from "../../reservations/lib/reservationPayment";

const CoverageAddedContent = ({ reservationId, insuranceName, amount, cardLast4, t }) => {
    const history = useHistory();
    const [navigating, setNavigating] = useState(false);

    const planName = insuranceName?.trim() || t("defaultPlanName");
    const showCharge = typeof amount === "number" && amount > 0;

    const handleBackToReservation = async () => {
        setNavigating(true);
        try {
            await fetchReservationById(reservationId);
        } finally {
            history.push(`/reservations/${reservationId}`);
        }
    };

    return (
        <div className="flex min-h-[70vh] flex-col items-center justify-center py-12 text-center">
            <div className="flex h-24 w-24 items-center justify-center rounded-full bg-[#5D5DF6]/15">
                <div className="flex h-14 w-14 items-center justify-center rounded-full bg-[#5D5DF6] text-white">
                    <CheckOutlined className="!text-2xl" />
                </div>
            </div>

            <h1 className="fontSemi mt-8 text-3xl text-[#2F2F46] sm:text-4xl">{t("coverageAddedTitle")}</h1>

            <div className="fontRegular mt-4 max-w-md space-y-1 text-base text-[#7f8c8d]">
                <p>{t("activeForTrip", { planName })}</p>
                {showCharge ? (
                    <p>
                        {cardLast4
                            ? t("chargedWithCard", {
                                  amount: amount.toFixed(2),
                                  last4: cardLast4,
                              })
                            : t("charged", { amount: amount.toFixed(2) })}
                    </p>
                ) : (
                    <p>{t("noCharge")}</p>
                )}
            </div>

            <Button
                type="primary"
                size="large"
                loading={navigating}
                onClick={handleBackToReservation}
                className="!mt-10 !h-12 !rounded-xl !px-8 !font-semibold">
                {t("backToReservation")}
            </Button>
        </div>
    );
};

CoverageAddedContent.propTypes = {
    reservationId: PropTypes.string.isRequired,
    insuranceName: PropTypes.string,
    amount: PropTypes.number,
    cardLast4: PropTypes.string,
    t: PropTypes.func.isRequired,
};

export default CoverageAddedContent;
